import React from 'react';
import { useGlobalContext } from '../Context';

const SearchForm = () => {
  const { setSearch } = useGlobalContext();
  const searchValue = React.useRef();
  const searchCocktail = () => {
    setSearch(searchValue.current.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  React.useEffect(() => {
    searchValue.current.focus();
  }, [searchValue]);
  return (
    <section className='section search'>
      <form className='search-form' onSubmit={handleSubmit}>
        <div className='form-control'>
          <label htmlFor='name'>Search your Favourite Cocktail</label>
          <input
            type='text'
            id='name'
            ref={searchValue}
            onChange={searchCocktail}
          />
        </div>
      </form>
    </section>
  );
};

export default SearchForm;
